<div class="input-dialog">
  <div class="dialog-header" *ngIf="data.title">
    <h2 class="dialog-title">{{ data.title }}</h2>
  </div>
  <div class="dialog-content">
    <p class="dialog-message" *ngIf="data.message">{{ data.message }}</p>
    <div class="input-wrapper" *ngIf="data.label || data.placeholder">
      <label class="input-label" *ngIf="data.label">{{ data.label }}</label>
      <input
        #inputElement
        class="dialog-input"
        type="{{ data.inputType || 'text' }}"
        [(ngModel)]="inputValue"
        [placeholder]="data.placeholder || ''"
        (keyup.enter)="onPrimaryClick()"
      />
    </div>

    <div class="room-type-wrapper" *ngIf="shouldShowRoomTypeSelect">
      <label class="input-label">{{ data.roomTypeLabel || ('select_room_type' | translate) }}</label>
      <app-x-select
        class="room-type-select"
        [options]="roomTypeMenuOptions"
        [value]="selectedRoomType || ''"
        (valueChange)="onRoomTypeChange($event)"
      ></app-x-select>
    </div>

    <div class="valuation-search" *ngIf="shouldShowValuationSearch">
      <label class="input-label valuation-search-label">
        {{ data.valuationSearchLabel || ('find_parcel_for_valuation' | translate) }}
      </label>
      <p class="valuation-search-hint">{{ 'valuation_search_hint' | translate }}</p>
      <app-search-feature
        class="valuation-search-feature"
        [placeholder]="data.roomSearchPlaceholder || ('search_parcels_placeholder' | translate)"
        [withSearchButton]="true"
        [uuidResultsOnlyMode]="true"
        (itemSelected)="onSearchResultSelected($event)"
      ></app-search-feature>
    </div>
    <div class="valuation-block" *ngIf="data.valuationBlockMessage">
      <p class="valuation-block-text">
        <ng-container *ngIf="valuationBlockMessageParts.hasInlineLink; else valuationBlockNoInline">
          {{ valuationBlockMessageParts.before }}
          <a
            *ngIf="hasValuationBlockLink"
            class="valuation-block-link"
            href="{{ data.valuationBlockLinkHref }}"
          >
            {{ valuationBlockLinkText }}
          </a>
          {{ valuationBlockMessageParts.after }}
        </ng-container>

        <ng-template #valuationBlockNoInline>
          {{ data.valuationBlockMessage }}
          <a
            *ngIf="hasValuationBlockLink"
            class="valuation-block-link"
            href="{{ data.valuationBlockLinkHref }}"
          >
            {{ valuationBlockLinkText }}
          </a>
        </ng-template>
      </p>
    </div>
  </div>

  <div class="dialog-submit-error" *ngIf="submitError">{{ submitError }}</div>

  <div class="dialog-actions">
    <app-x-button
      *ngIf="data.secondaryButton"
      [size]="'28'"
      [style]="data.secondaryButton.style || 'outlined-black'"
      [disabled]="isSubmitting"
      (click)="onSecondaryClick()">
      {{ data.secondaryButton.text }}
    </app-x-button>
    <app-x-button
      *ngIf="data.primaryButton"
      [size]="'28'"
      [style]="data.primaryButton.style || 'filled-black'"
      [disabled]="isPrimaryDisabled"
      [loading]="isSubmitting"
      (click)="onPrimaryClick()">
      {{ data.primaryButton.text }}
    </app-x-button>
  </div>
</div>

